<template>
  <path
    d="M8.70999 12.2902L11.3 9.70021C11.69 9.31021 12.32 9.31021 12.71 9.70021L15.3 12.2902C15.93 12.9202 15.48 14.0002 14.59 14.0002H9.40999C8.51999 14.0002 8.07999 12.9202 8.70999 12.2902Z"
  />
</template>
